import { Map } from "immutable"

import {
    DIMENSION_LIST_REQUEST as LIST_REQUEST,
    DIMENSION_LIST_RESPONSE as LIST_RESPONSE,
    DIMENSION_LIST_CACHED_RESPONSE as LIST_CACHED_RESPONSE,
    DIMENSION_LIST_ERROR_RESPONSE as LIST_ERROR_RESPONSE
} from "../../actions/action-types"
import buildPagingReducer from "./build-paging-reducer"

export const defaultSearchCriteria = Map({
    name: "",
    search: ""
})

export default buildPagingReducer(
    {
        LIST_REQUEST,
        LIST_RESPONSE,
        LIST_CACHED_RESPONSE,
        LIST_ERROR_RESPONSE
    },
    defaultSearchCriteria
)
